import { useSetRecoilState } from "recoil";

import { confirmationState } from "./confirmationState";

interface confirmObject {
  title?: string;
  text?: string;
  submitText?: string;
  cancelText?: string;
}

export const useConfirm = () => {
  const setConfirmation = useSetRecoilState(confirmationState);

  return ({ title, text, submitText, cancelText }: confirmObject) =>
    new Promise<boolean>((resolve) => {
      const onSubmit = () => {
        resolve(true);
        setConfirmation(undefined);
      };

      const onCancel = () => {
        resolve(false);
        setConfirmation(undefined);
      };

      setConfirmation({
        title,
        text,
        cancelText,
        submitText,
        onSubmit,
        onCancel,
      });
    });
};
